<template>
	<div class="pages">
		<div class="home">
			<div class="home-title flex flex-align-center">
				<img src="@/static/images/logo.png" class="logo" />
				<router-link :to="{name: 'search'}">
					<div class="keyWords flex-1 flex flex-align-center">
						<img src="@/static/images/my/search.png" class="search" />
						<input disabled type="text" class="flex-1" placeholder="请输入关键字搜索"/>
					</div>
				</router-link>
				<!-- <van-icon name="chat-o" badge="99+" size="20" /> -->
			</div>

			<swiper ref="myHomeSwiper" class="home-swiper" :options="myHomeSwiperOptions">
				<swiper-slide v-for="item in bannerList" :key="item.id" class="home-swiper-slide">
					<img @click="toHref(item.url)" :src="item.image" alt="" />
				</swiper-slide>

				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>

			<div class="itemList flex flex-align-center flex-jus-between">
				<router-link :to="{name:'introduction'}">
				<div class="item flex flex-column">
					<img src="@/static/images/index/jianjie.png" alt="" />
					<div class="name">学会简介</div>
				</div>
				</router-link>
				<router-link :to="{name:'office'}">
				<div class="item flex flex-align-center flex-column">
					<img src="@/static/images/index/banshichu.png" alt="" />
					<div class="name">办事处</div>
				</div>
				</router-link>
				<router-link :to="{name:'resources'}">
				<div class="item flex flex-align-center flex-column">
					<img src="@/static/images/index/jiaoxueziyuan.png" alt="" />
					<div class="name">教学园地</div>
				</div>
				</router-link>
				<router-link :to="{name:'activityList'}">
				<div class="item flex flex-align-center flex-column">
					<img src="@/static/images/index/huodongbaoming.png" alt="" />
					<div class="name">活动报名</div>
				</div>
				</router-link>
				<div @click="toMember" class="item flex flex-align-center flex-column">
					<img src="@/static/images/index/chengyuan.png" alt="" />
					<div class="name">学会成员</div>
				</div>
			</div>
			
			<div class="card">
				<div class="leftIcon"></div>
				<div class="rightIcon"></div>
				<div class="title">{{commonConfig.association_name}}</div>
				<div @click="showPicker = true" class="location flex flex-align-center">
					<img src="@/static/images/index/location.png" alt="">
					<div>{{commonConfig.association_address}}</div>
				</div>
				<div v-if="vip.status != 1" @click="toJoin" class="join flex flex-align-center flex-jus-center">
					<img src="@/static/images/index/join.png" alt="">
					<div>入会</div>
				</div>
				
			</div>
			
			<router-link :to="{name:'news_List'}">
			<div class="homtTitle flex flex-align-center">
				<div class="left">学会资讯</div>
				<div class="more flex-1">更多</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow">
			</div>
			</router-link>
			
			<div class="newsList">
				<div class="news flex flex-align-center flex-jus-between" v-for="item in acticle_list" :key="item.id" @click="toArticle(item)">
					<img :src="item.pic" class="img">
					<div class="content flex-1 flex flex-column flex-jus-between">
						<div class="cotent-title no-wrap-2">{{item.title}}</div>
						<div class="content-time">{{item.create_time | formatDate_noS}}</div>
					</div>
				</div>
			</div>
			
			<router-link :to="{name:'expert'}">
			<div class="homtTitle flex flex-align-center">
				<div class="left">专家风采</div>
				<div class="more flex-1">更多</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow">
			</div>
			</router-link>
			<swiper ref="myExpertSwiper" class="expertSwiper" :options="myExpertSwiperOptions">
				<swiper-slide v-for="item in expert_list" :key="item.id" class="expertSwiper-slide"><img @click="$router.push(`/home/expert/details?id=${item.id}`)" :src="item.avatar" alt="" /></swiper-slide>
			</swiper>

			<div class="homtTitle flex flex-align-center">
				<div class="left">名师推荐</div>
				<div @click="$router.push({'name': 'teacher'})" class="more flex-1">更多</div>
				<img src="@/static/images/icon-arrowRight.png" class="arrow">
			</div>
			
			<div class="recommendList flex flex-wrap flex-align-center">
				<div @click="$router.push(`/home/teacher/detail?id=${item.id}`)" class="recommend flex flex-column flex-align-center" v-for="item in famous_teacher_list" :key="item.id" >
					<img :src="item.avatar" class="avatar">
					<div class="name">{{item.truename}}</div>
					<div class="des">福建省民族管弦乐 学会会员</div>
				</div>
			</div>
		</div>
		<tabbar :tabbar="0"></tabbar>
		<van-popup v-model="showPicker" round position="bottom">
			<van-picker
				title="选择地图"
				show-toolbar
				:columns="maps"
				@confirm="onConfirm"
				@cancel="showPicker = false"
			/>
		</van-popup>
	</div>
</template>

<script>
/* eslint-disable */
import {mapState} from 'vuex';
export default {
	watch: {},
	data() {
		return {
			bannerList: [],
			acticle_list: [], // 文章
			expert_list: [], // 专家
			famous_teacher_list: [], // 名师列表

			myHomeSwiperOptions: {
				autoplay: {
					delay: 3000 //1秒切换一次
				},
				pagination: {
					el: '.swiper-pagination'
				}
			},

			myExpertSwiperOptions: {
				autoplay: {
					delay: 3500 //1秒切换一次
				},
				paginationClickable: true,
				centeredSlides: true,
				slidesPerView: 2

			},
			is_vip: 0,
			vip: {},

			showPicker: false,
			maps: [
				'腾讯地图',
				'高德地图',
				'百度地图'
			]
		};
	},
	computed: {
		...mapState(['commonConfig']),
		myExpertSwiper() {
			return this.$refs.myExpertSwiper.$swiper;
		}
	},
	created() {
		this.getBanner()
		this.getIndex()
		this.getUserInfo()
	},
	mounted() {
		// this.myExpertSwiper.slideTo(3, 1000, false);
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		toHref(url) {
			location.href = url
		},
		getBanner() {
			this.$get('api/common/getBanner', {
				type: 1
			}).then(res => {
				this.bannerList = res.data
			})
		},
		getIndex() {
			this.$get('api/index/index', {
				acticle_limit: 5
			}).then(res => {
				this.acticle_list = res.data.acticle_list
				this.expert_list = res.data.expert_list
				this.famous_teacher_list = res.data.famous_teacher_list
			})
		},
		getUserInfo() {
			this.$get('api/user/userInfo').then(res => {
				let result = res.data
				this.is_vip = result.is_vip
				if (!Array.isArray(result.vip)) {
					this.vip = result.vip || {}
				}
			})
		},
		toArticle(data) {
			if (data.is_link == 1) {
				location.href = data.link
				return
			}
			this.$router.push({'name': 'news_details', query: {id: data.id}})
		},
		toJoin() {
			let Mobile = localStorage.getItem('mobile')
			if (!Mobile) {
				this.$router.push('/login/loginPhone')
			} else {
				this.$router.push(`/my/apply`)
			}
		},
		onConfirm(e) {
			let url = '';
			let lat = this.commonConfig.longitude_latitude.split(',')[1]
			let lng = this.commonConfig.longitude_latitude.split(',')[0]
			let address = this.commonConfig.association_address
      switch(e) {
				case '腾讯地图':
						// https://apis.map.qq.com/uri/v1/marker?marker=coord:39.91999,116.45627;addr:北京市朝阳区呼家楼街道万通中心A座;title:地址&referer=keyfree
						url = 'https://apis.map.qq.com/uri/v1/marker?marker=coord:' + lat + ',' + lng  +';addr:'+ address +';title:地址&referer=keyfree';
						break;
				case '高德地图':
						url = 'https://uri.amap.com/marker?position='+ lng + ',' + lat +'&name='+ address +'&callnative=1';
						break;
				case '百度地图':
						url = 'http://api.map.baidu.com/marker?location=' + lat + ',' +  lng +'&title=地址&content='+ address +'&output=html&src=webapp.reformer.appname&coord_type=gcj02';
						break;
				default:
						break;
      }
			location.href=url
		},
		toMember() {
			if (this.is_vip != 1) {
				this.$toast('您还不是学会会员')
				return
			}
			this.$router.push({name:'member'})
		}
	}
};
</script>

<style scoped lang="stylus">
.pages
	padding-bottom 150px
	
.swiper-container
	--swiper-theme-color #5A0013
	--swiper-pagination-color #DE113C /* 两种都可以 */
.expertSwiper
	margin-top 15px
	width 100%
	height 364px !important
	.expertSwiper-slide
		width 320px
		height 364px
		padding 28px 24px
		transition 0.2s linear
		img
			width 100%
			height 100%
			border-radius 10px
			object-fit cover
	.swiper-slide-active
		transform scale(1.2)
.home
	padding 0 30px
	padding-top 160px
	background-color #FFFFFF
	.home-title
		position fixed
		z-index 99
		top 0
		left 0
		width 100%
		background #fff
		padding 40px 30px
		.logo
			width 72px
			height 72px
		.message
			width 46px
			height 46px
		.keyWords
			margin 0 40px
			// margin 0 80px
			// width 100%
			width 492px
			height 72px
			padding 18px 26px
			background-color rgba(247, 247, 247, 1)
			font-size 26px
			color #ABABAB
			border-radius 46px
			.search
				width 34px
				height 36px
				margin-right 26px
			input
				background-color inherit
	.home-swiper
		width 100%
		height 296px
		border-radius 20px
		.home-swiper-slide
			width 100%
			height 100%
			border-radius 20px
			img
				width 100%
				height 100%
				border-radius 20px
				object-fit: cover;
	.itemList
		margin-top 40px
		.item
			img
				width 100px
				height 100px
			.name
				margin-top 24px
				font-size 26px
				color #000000
	.card
		width 100%
		height 230px
		background #FFFFFF
		box-shadow 0px 8px 24px rgba(0, 0, 0, 0.06)
		border-radius 10px
		padding 24px
		margin-top 40px
		position relative
		.leftIcon
			position absolute
			top 0
			left 0
			width 8px
			height 100%
			background-image url('~@/static/images/index/card-leftIcon.png')
			background-size 100% 100%
			background-position center
		.rightIcon
			position absolute
			top 0
			right 0
			width 232px
			height 206px
			background-image url('~@/static/images/index/card-rightIcon.png')
			background-size 100% 100%
			background-position center
		.title
			font-size: 32px;
			font-weight: bold;
			color: #333333;
		.location
			margin-top 18px
			font-size: 24px;
			color: #A5A5A5;
			img
				width 24px
				height 32px
				margin-right 12px
		.join
			margin-top 28px
			width 164px
			height 60px
			background-image url('~@/static/images/index/joinBG.png')
			background-size 100% 100%
			background-position center
			font-size: 28px
			color: #FFFFFF;
			img
				width 32px
				height 32px
				margin-right 8px
	.homtTitle
		margin-top 40px
		width 100%
		height 70px
		background-image url('~@/static/images/index/titleBG.png')
		background-size 100px 70px
		background-position left
		background-repeat no-repeat
		.left
			margin-left 25px
			font-size: 36px;
			font-weight: 800;
			color: #151925;
		.more
			text-align right
			font-size: 26px;
			font-weight: 500;
			color: #B1B1B1;
		.arrow
			width 12px
			height 22px
			margin-left 12px
	.newsList
		.news
			margin-top 28px
			width 100%
			height 180px
			.img
				width 272px
				height 180px
				border-radius: 10px;
			.content
				height 180px
				margin-left 24px
				.cotent-title
					font-size: 30px;
					font-weight: bold;
					color: #111111;
				.content-time
					font-size: 26px;
					color: #B1B1B1;
	.recommendList
		margin-top 32px
		.recommend
			width 220px
			height 268px
			background-image url('~@/static/images/index/recommendBG.png')
			background-size 100% 100%
			background-position center
			padding 22px 14px
			text-align center
			margin-right 14px
			margin-bottom 14px
			&:nth-child(3n)
				margin-right 0
			.avatar
				width 100px
				height 100px
				border-radius 50%
			.name
				margin-top 10px
				font-size: 26px;
				font-weight: bold;
				color: #111111;
			.des
				margin-top 12px
				width 100%
				font-size: 22px;
				color: #7B6E5F;
</style>

